import React, {useEffect,useState,useRef} from 'react'
import { useParams } from 'react-router-dom';

import { Link } from 'react-router-dom';

import './Model.css';

import Header from '../../sections/Header/Header';
import Footer from '../../sections/Footer/Footer';
import Dropdown from '../../components/Dropdown/Dropdown';
import Table from '../../components/Table/Table';
import PreviewSlider from '../../components/Slider/PhotoSlider/PhotoSlider';
import MoreTalent from '../Talent/components/MoreTalent';

import Splash1 from '../../../tmp/splash1.jpg';
import photoGirl1 from '../../../tmp/sara1.jpg';
import photoGirl2 from '../../../tmp/veronika1.jpg';
import photoGirl3 from '../../../tmp/kristina1.jpg';

const Model = () => {

    const photos = [
        photoGirl1, Splash1, photoGirl2, photoGirl3
    ]

    const {city,model} = useParams();

    const [modelName,setModelName] = useState(false)
    const [cityName,setCityName] = useState(false)

    useEffect(() => {
        window.scrollTo(0, 0)
    }, [])

    useEffect(() => {
        setCityName(city)
    }, [cityName,city])

    useEffect(() => {
        setModelName(model)
    }, [modelName,model])

    return (
        <>
            <Header whitebar={true} />
            <section className="model">
                <div className="model-view left">
                    <div className="model-view-desktop">
                        {
                            photos.map((photo) => {
                                return <div className="model-photo">
                                        <img src={photo} />
                                    </div>
                                })
                        }
                        <MoreTalent 
                            prev={{
                                'name':'Sara',
                                'link':'/models/rome/sara',
                                'city':'Rome',
                                'photo':photos[2]
                            }}
                            next={{
                                'name':'Diana',
                                'link':'/models/rome/diana',
                                'city':'Milan',
                                'photo':photos[0]
                            }}
                        />
                        <Footer type={'side'} />
                    </div>
                    <div className="model-view-mobile">
                        <PreviewSlider col={1} images={photos} />
                    </div>
                </div>
                <div className="model-view right">
                    <div className="right-container scrollable">
                        <div className="model-name">
                            {modelName}
                        </div>
                        <div className="model-city">
                            {cityName}
                        </div>
                        <Dropdown 
                            title={'Description'} 
                            defaultStatus={true} 
                            pad={true}
                            content={
                                <>
                                    <p>One of a kind.</p>
                                    <p>A captivating and sensual model exudes an effortless elegance, with every glance and movement drawing attention. 
                                        Her beauty is mesmerizing, blending natural grace with a magnetic aura that commands presence. Delicate features 
                                        frame her face, with soft curves and a radiant complexion that glows in any light. Her eyes, expressive and 
                                        alluring, seem to tell stories with each gaze, while her lips hold an inviting warmth.
                                    </p>
                                    <p> She carries herself with 
                                        confidence, embodying both strength and femininity. Every pose is deliberate, accentuating her form and leaving a 
                                        lasting impression of refined sensuality.
                                    </p>
                                    <div className="book-now">
                                        <Link to={'/contact/'+modelName}>Request</Link>
                                    </div>
                                </>
                            }    
                        />
                        <Dropdown 
                            title={'Model Parameters'}
                            content={
                                <>
                                    <Table columns={
                                        [
                                            {
                                                "id":"height",
                                                "label":"Height",
                                                "class":"height-col"
                                            },
                                            {
                                                "id":"weight",
                                                "label":"Weight",
                                                "class":"weight-col"
                                            },
                                            {
                                                "id":"body",
                                                "label":"Body",
                                                "class":"body-col"
                                            },
                                            {
                                                "id":"hair",
                                                "label":"Hair",
                                                "class":"hair-col"
                                            },
                                            {
                                                "id":"eyes",
                                                "label":"Eyes",
                                                "class":"eyes-col"
                                            },
                                            {
                                                "id":"breast",
                                                "label":"Breast",
                                                "class":"breast-col"
                                            }
                                        ]
                                    } data={[
                                        {
                                            "height":"165cm",
                                            "weight":"50kg",
                                            "body":"36-34-36",
                                            "hair":"black",
                                            "eyes":"green",
                                            "breast":"DD"
                                        }
                                    ]} />
                                </>
                            }    
                        />

                        <Dropdown 
                            title={'City Rates'}
                            content={
                                <>
                                    <Table columns={
                                        [
                                            {
                                                "id":"duration",
                                                "label":"Duration",
                                                "class":"duration-col"
                                            },
                                            {
                                                "id":"incall",
                                                "label":"Incall",
                                                "class":"incall-col"
                                            },
                                            {
                                                "id":"outcall",
                                                "label":"Outcall",
                                                "class":"outcall-col"
                                            }
                                        ]
                                    } data={[
                                        {
                                            "duration":"30 Minutes",
                                            "incall":"300€",
                                            "outcall":"N/A"
                                        },
                                        {
                                            "duration":"1 Hour",
                                            "incall":"500€",
                                            "outcall":"550€"
                                        },
                                        {
                                            "duration":"2 Hour",
                                            "incall":"750€",
                                            "outcall":"800€"
                                        },
                                        {
                                            "duration":"3 Hour",
                                            "incall":"1000€",
                                            "outcall":"1050€"
                                        },
                                        {
                                            "duration":"4 Hour",
                                            "incall":"1250€",
                                            "outcall":"1300€"
                                        }
                                    ]} />
                                </>
                            }    
                        />

                        <Dropdown 
                            title={'Travel Rates'}
                            content={
                                <>
                                    <Table columns={
                                        [
                                            {
                                                "id":"duration",
                                                "label":"Duration",
                                                "class":"duration-col"
                                            },
                                            {
                                                "id":"incall",
                                                "label":"Incall",
                                                "class":"incall-col"
                                            },
                                            {
                                                "id":"outcall",
                                                "label":"Outcall",
                                                "class":"outcall-col"
                                            }
                                        ]
                                    } data={[
                                        {
                                            "duration":"24 Hours",
                                            "incall":"3000€",
                                            "outcall":"3500€"
                                        },
                                        {
                                            "duration":"48 Hours",
                                            "incall":"5000€",
                                            "outcall":"5500€"
                                        },
                                        {
                                            "duration":"72 Hour",
                                            "incall":"7500€",
                                            "outcall":"8000€"
                                        }
                                    ]} />
                                </>
                            }    
                        />
                    </div>
                </div>
                <div className="model-view-mobile">
                    <MoreTalent 
                            prev={{
                                'name':'Sara',
                                'link':'/models/rome/sara',
                                'city':'Rome',
                                'photo':photos[2]
                            }}
                            next={{
                                'name':'Diana',
                                'link':'/models/rome/diana',
                                'city':'Milan',
                                'photo':photos[0]
                            }}
                    />
                    <Footer />
                </div>
            </section>

            
        </>
    )
}

export default Model;